//Copyright Open Trade Technology Ltd. 2023. All rights reserved.

import '@react/App.css'
import React from 'react'

import AdminApp from '@react/admin/AdminApp'
import BorrowerApp from '@react/borrower/BorrowerApp'
import { useOtChainState } from '@react/redux/store'
import { RoleEnum } from '@shared/Enums'
import UnconnectedApp from './UnconnectedApp'
import { Typography } from '@mui/material'
import OperatorApp from '@react/operator/OperatorApp'

const DISPLAY_APP_UPDATING = false
export function AppForRoleAdmin(): React.ReactElement {
  document.title = 'OpenTradeAdmin'
  const {
    userConnection: { roleEnum },
  } = useOtChainState()

  let content

  if (roleEnum === RoleEnum.OPERATOR) {
    content = <OperatorApp />
  } else if (roleEnum === RoleEnum.POOL_ADMIN) {
    content = <AdminApp />
  } else if (roleEnum === RoleEnum.BORROWER) {
    content = <BorrowerApp />
  } else if (roleEnum === RoleEnum.LENDER) {
    if (location.hostname.startsWith('admin.')) {
      content = <UnconnectedApp transferLocation={location.hostname.replace('admin', 'app')} />
    } else {
      content = <UnconnectedApp />
    }
  } else {
    content = <UnconnectedApp />
  }

  return (
    <div className="app-container" data-testid="AppForRoleAdmin">
      {DISPLAY_APP_UPDATING && <Typography variant="h1">Update in Progress.... App will return soon</Typography>}

      {!DISPLAY_APP_UPDATING && <div style={{ flex: 1, overflow: 'auto' }}>{content}</div>}
    </div>
  )
}
